import { render, staticRenderFns } from "./ReportPromoSA.vue?vue&type=template&id=7b0f6770"
import script from "./ReportPromoSA.vue?vue&type=script&lang=js"
export * from "./ReportPromoSA.vue?vue&type=script&lang=js"
import style0 from "./ReportPromoSA.vue?vue&type=style&index=0&id=7b0f6770&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports